export const createTestIdFactory = (rootTestId?: string | null) => (childId: string) => {
  if (!rootTestId) {
    return childId;
  }

  return `${rootTestId}--${childId}`;
};